type PdfCell = string | null | undefined;

const escapeHtml = (str: string): string =>
  str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export const downloadPdf = (
  title: string,
  headers: string[],
  rows: PdfCell[][]
): void => {
  const printWindow = window.open("", "_blank", "width=1100,height=750");
  if (!printWindow) return;

  const headerHtml = headers.map((h) => `<th>${escapeHtml(h)}</th>`).join("");
  const bodyHtml = rows
    .map(
      (row) =>
        `<tr>${row.map((cell) => `<td>${escapeHtml(cell ?? "")}</td>`).join("")}</tr>`
    )
    .join("");

  printWindow.document.write(`
    <!DOCTYPE html>
    <html lang="fr">
    <head>
      <meta charset="UTF-8" />
      <title>${title}</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 11px; color: #1a1a2e; margin: 0; padding: 16px; }
        h1 { font-size: 15px; margin-bottom: 12px; }
        table { width: 100%; border-collapse: collapse; }
        thead th { background: #1a3050; color: #fff; padding: 8px 10px; text-align: left; }
        tbody td { padding: 6px 10px; border-bottom: 1px solid #e0e4ea; }
        tbody tr:nth-child(even) td { background: #f5f7fa; }
        @page { margin: 15mm 10mm; size: A4 landscape; }
      </style>
    </head>
    <body>
      <h1>${title}</h1>
      <table>
        <thead><tr>${headerHtml}</tr></thead>
        <tbody>${bodyHtml}</tbody>
      </table>
    </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};
